import {runOrQueueToolCall} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/handlers/appToolCallHandler/ide/ideToolCallHandler.ts";
import {addToolMessage} from "../../../llm/responseStream/receiver/toolCallHandlers/toolCallFinish/utils/utils.ts";

export const handleGiveFileAlterResults = async (data: any, llmRequestRefs: any, currentMessageRef: any, messagesSequenceRef: any, setMessages: any, messagesRef: any, updateElementInProgress: any, updateUnreviewedFileTracker: any, environmentObjRef: any, dynamicStateObjRef: any) => {
    try {
        const fileErrors = JSON.parse(data[0]);
        const newFileContents = JSON.parse(data[1]);
        const languageName = data[2];
        const filePath = data[3];
        const startLine = parseInt(data[4]);
        const fileSizeDiff = parseInt(data[5]);
        const toolCallId = data[6];
        const originalContents = data[7] ? JSON.parse(data[7]) : null;
        const operation = data[8];
        const originalFilePath = data[9];

        // If we have not seen the file in the tracker yet, or it's a move operation
        if (!(filePath in dynamicStateObjRef.current.unreviewedFileTracker) || operation === "move" || operation === "delete") {
            // Clear all existing states for move operations
            if (operation === "move") {
                if (filePath in dynamicStateObjRef.current.unreviewedFileTracker) updateUnreviewedFileTracker(filePath, null, "delete");
                if (originalFilePath in dynamicStateObjRef.current.unreviewedFileTracker) updateUnreviewedFileTracker(originalFilePath, null, "delete");
            }
            // If we delete a file it doesn't matter what happened before really
            else if (operation === "delete") {
                if (filePath in dynamicStateObjRef.current.unreviewedFileTracker) updateUnreviewedFileTracker(filePath, null, "delete");
            }
            updateUnreviewedFileTracker(filePath, {operation, originalContents: originalContents, originalFilePath: originalFilePath}, "add");
        }
        llmRequestRefs.current.additionalContext.filesAlreadySeen.add(filePath);
        llmRequestRefs.current.additionalContext.mostRecentFileStates[filePath] = {languageName: languageName, fileContents: newFileContents};

        if (!(filePath in llmRequestRefs.current.additionalContext.toolCallAdjustments)) {
            llmRequestRefs.current.additionalContext.toolCallAdjustments[filePath] = [[startLine, fileSizeDiff]];
        } else {
            const adjustments = llmRequestRefs.current.additionalContext.toolCallAdjustments[filePath];
            let insertIndex = adjustments.findIndex((adj: any) => adj[0] > startLine);
            if (insertIndex === -1) {
                insertIndex = adjustments.length;
            }
            adjustments.splice(insertIndex, 0, [startLine, fileSizeDiff]);
        }

        const { id, name, args } = llmRequestRefs.current.toolCalls[toolCallId];
        addToolMessage({ id, name, args }, {newFileContents, languageName, fileErrors}, llmRequestRefs, currentMessageRef, messagesSequenceRef, setMessages, messagesRef);
        updateElementInProgress(toolCallId, 'delete');
        llmRequestRefs.current.toolCallQueue = llmRequestRefs.current.toolCallQueue.filter((toolCall: any) => toolCall.id !== toolCallId);
        await runOrQueueToolCall(llmRequestRefs, "trigger", environmentObjRef, null, null);
    } catch (error) {
        console.error("Error in handleGiveFileAlterResults:", error);
    }
};